import extend from 'dva-model-extend';
import _ from 'lodash';

import { CAPTCHA_CODE } from '../common/constants';
import * as services from './service';

import captchaModel from '../components/HumanCaptcha/model';
import {
  LOCAL_EMAIL_INPUT_KEY,
  LOCAL_EMAIL_TIME_KEY,
  LOCAL_PHONE_INPUT_KEY,
  LOCAL_PHONE_TIME_KEY,
  NAMESPACE,
} from './constants';
import { loopCrypto, resolveContryCode } from '../common/tools';

const sendChannelMap = {
  SMS: {
    localStorageTimeKey: LOCAL_PHONE_TIME_KEY,
    localStorageInputFn: (params) => {
      localStorage.setItem(LOCAL_PHONE_INPUT_KEY, params.phone);
    },
    resetFn: services.resetPhonePwd,
  },
  VOICE: {
    localStorageTimeKey: LOCAL_PHONE_TIME_KEY,
    localStorageInputFn: (params) => {
      localStorage.setItem(LOCAL_PHONE_INPUT_KEY, params.phone);
    },
    resetFn: services.resetPhonePwd,
  },
  EMAIL: {
    localStorageTimeKey: LOCAL_EMAIL_TIME_KEY,
    localStorageInputFn: (params) => {
      localStorage.setItem(LOCAL_EMAIL_INPUT_KEY, params.email);
    },
    resetFn: services.resetEmailPwd,
  },
};

const initialValue = {
  isCount: false,
  loading: false,
  isCodeRegx: false,
  sendChannel: 'SMS',
  email: '',
  phone: '',
  countryCode: '',
  bizType: 'FORGOT_PASSWORD',
  countTime: {},
  countryCodes: [],
  SMS_countTime: {},
  EMAIL_countTime: {},
};
export default extend(captchaModel, {
  namespace: NAMESPACE,
  state: initialValue,
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: {
    // 发送验证码
    *sendVerifyCode({ payload }, { call, put }) {
      const { email, phone, countryCode, bizType, toast, sendChannel } = payload;
      const { localStorageTimeKey, localStorageInputFn } = sendChannelMap[sendChannel];
      localStorageInputFn({ email, phone });
      localStorage.setItem(localStorageTimeKey, +new Date());
      yield put({ type: 'update', payload: { loading: true } });
      const address = ['SMS', 'VOICE'].includes(sendChannel)
        ? `${resolveContryCode(countryCode)}-${phone}`
        : email;
      try {
        const result = yield call(services.sendVerifyCode, {
          address,
          bizType,
          sendChannel,
        });
        const { data: { maxRetryTimes, retryTimes, retryAfterSeconds } = {}, msg, code } = result;
        // 发送验证码，如果达到最大次数，则给出一个提示
        if (maxRetryTimes === retryTimes) {
          toast.warning(msg);
        }
        if (code === '200') {
          const _sendChannel = sendChannel === 'VOICE' ? 'SMS' : sendChannel;
          yield put({
            type: 'update',
            payload: {
              sendChannel,
              isCount: true,
              [`${_sendChannel}_countTime`]: { time: retryAfterSeconds },
            },
          });
          toast.info(msg);
        }
      } catch (err) {
        if (err.code && err.code === CAPTCHA_CODE) {
          yield put({
            type: 'captchaInit',
            payload: {
              bizType,
              onCallBack: {
                type: 'sendVerifyCode',
                payload,
              },
            },
          });
        } else {
          const msg = _.isObject(err) ? JSON.stringify(err.msg) : err;
          toast.error(msg);
        }
      } finally {
        yield put({ type: 'update', payload: { loading: false } });
      }
    },
    // 验证验证码
    *verifyCode({ payload }, { call, put }) {
      const { email, phone, countryCode, bizType, code, toast, sendChannel } = payload;
      try {
        const address = ['SMS', 'VOICE'].includes(sendChannel)
          ? `${resolveContryCode(countryCode)}-${phone}`
          : email;
        const { code: dataCode, msg } = yield call(services.verifyCode, {
          address,
          [`validations[${sendChannel.toLowerCase()}]`]: code,
          bizType,
        });
        if (dataCode !== '200') {
          toast.error(msg);
          yield put({ type: 'update', payload: { isCodeRegx: false } });
          return;
        }
        // 更新codeRegx
        yield put({
          type: 'update',
          payload: {
            isCodeRegx: true,
            email,
            phone,
            countryCode,
            sendChannel,
          },
        });
      } catch (err) {
        yield put({
          type: 'update',
          payload: {
            isCodeRegx: false,
          },
        });
        const msg = _.isObject(err) ? JSON.stringify(err.msg) : err;
        toast.error(msg);
      }
    },
    // 重置密码
    *resetPwd({ payload }, { call, select }) {
      const { toast, password } = payload;
      const { email, phone, countryCode, sendChannel } = yield select((state) => state[NAMESPACE]);
      try {
        const { resetFn } = sendChannelMap[sendChannel];
        const opts = {
          password: loopCrypto(password, 2),
        };
        if (['SMS', 'VOICE'].includes(sendChannel)) {
          opts.phone = phone;
          opts.countryCode = countryCode;
        } else {
          opts.email = email;
        }
        const { code: dataCode, msg } = yield call(resetFn, {
          ...opts,
        });
        if (dataCode !== '200') {
          toast.error(msg);
          return false;
        }
        toast.info(msg);
        return true;
      } catch (err) {
        const msg = _.isObject(err) ? JSON.stringify(err.msg) : err;
        toast.error(msg);
        return false;
      }
    },
    // 重置所有参数
    *resetInit(_, { put }) {
      yield put({
        type: 'update',
        payload: initialValue,
      });
    },

    *getCountryCodes(_, { call, put }) {
      const { data } = yield call(services.getCountryCodes);
      yield put({
        type: 'update',
        payload: {
          countryCodes: data,
        },
      });
    },
  },
});
